import * as React from 'react';
import { CloseOnBlur } from 'ui/common/close-on-blur';
import { MdMenu as MdBurger, MdClose } from 'react-icons/md';
import { FixedDocument } from 'app/components/fixed-document';
import { HeaderProps, HeaderState } from '../../types';
import { When } from './menu-items/when';
import { MainMenuItems } from './menu-items/main-menu-items';
import { ToolsMenu } from './menu-items/tools-menu';
import { FooterMenuItems } from './menu-items/footer-menu-items';
import styles from './mobile-nav.scss';

export class MobileNav extends React.Component<HeaderProps, HeaderState> {

  public state: Readonly<HeaderState> = {
    menuIsOpen: false,
    menuIsClosing: false
  };

  private openMenu = () => {
    this.setState({ menuIsOpen: true });
  };

  private closeMenu = () => {
    this.setState({ menuIsClosing: true });
    setTimeout(() => {
      this.setState({
        menuIsOpen: false,
        menuIsClosing: false
      });
    }, 300);
  };

  public render() {
    const {
      translation, menuAccess, manageSurveysUrl, aiChatAssistantAccessInfo, instanceInfo, helpUrl, feedbackUrl
    } = this.props;
    return (
      <CloseOnBlur onBlur={this.closeMenu}>
        <div className={styles.mobileNav}>
          <div className="container main-grid">

            <When condition={!this.state.menuIsOpen}>
              <button className={`btn ${styles.hamburger}`} onClick={this.openMenu}>
                <span>{translation.menu}</span>
                <MdBurger className={styles.navItemIcon} />
              </button>
            </When>

            <When condition={this.state.menuIsOpen}>
              <button className={`btn ${styles.hamburger}`} id={styles.closeBtn} onClick={this.closeMenu}>
                <span>{translation.menu}</span>
                <MdClose className={styles.navItemIcon} />
              </button>
            </When>
          </div>

          <When condition={this.state.menuIsOpen}>
            <FixedDocument>
              <div>
                <ul className={`list-group dropdown-menu ${styles.dropdownList}
              ${this.state.menuIsClosing ? styles.animateOut : ''}`}>
                  <MainMenuItems
                    translation={translation}
                    aiChatAssistantAccessInfo={aiChatAssistantAccessInfo}
                    instanceInfo={instanceInfo}
                    onItemClick={this.closeMenu}
                  />
                  <ToolsMenu
                    translation={translation}
                    menuAccess={menuAccess}
                    manageSurveysUrl={manageSurveysUrl}
                    onItemClick={this.closeMenu}
                    onRefreshCache={this.props.onRefreshCache}
                    onRegenerateAggregatedEnv={this.props.onRegenerateAggregatedEnv}
                    onRegenerateAggregatedRisk={this.props.onRegenerateAggregatedRisk}
                  />
                  <FooterMenuItems
                    translation={translation}
                    helpUrl={helpUrl}
                    feedbackUrl={feedbackUrl}
                    onItemClick={this.closeMenu}
                  />

                </ul>
                <div className={`${styles.background} ${this.state.menuIsClosing ? styles.animateOut : ''}`} onClick={this.closeMenu} />
              </div>
            </FixedDocument>
          </When>
        </div>

      </CloseOnBlur>
    );
  }
}
